import { CreateDisplayGroupRole, CreateDisplayGroupRoleVariables } from './__generated__/CreateDisplayGroupRole'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

export const CREATE_DISPLAY_GROUP_ROLE_MUTATION = gql`
  mutation CreateDisplayGroupRole($input: CreateDisplayGroupRoleInputV2!) {
    createDisplayGroupRoleV2(input: $input) {
      ... on DisplayGroupInviteV2 {
        id
        email
        role
      }
      ... on DisplayGroupRoleErrorV2 {
        type
        error
      }
      ... on DisplayGroupRoleV2 {
        id
        role
        person {
          id
          emailAddress
          firstName
          lastName
        }
      }
    }
  }
`

export const useCreateDisplayGroupRole = () => {
  return useMutation<CreateDisplayGroupRole, CreateDisplayGroupRoleVariables>(CREATE_DISPLAY_GROUP_ROLE_MUTATION)
}
